import React from "react";
import * as dc from "dc";
import * as d3 from 'd3';
import { scaleLinear, scaleTime, timeMonth, timeMonths } from "d3";
import { ChartTemplate } from "./chartTemplate";


//const self = this;
const barChartFunc = (divRef, ndx) => {
  //console.log('dim '+ self.dim)
    let name = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const myChart = dc.barChart(divRef);
    const formatMonth = d3.timeFormat("%b"),
      formatDay = d3.timeFormat("%A")
    //let month;
    const dimension = ndx.dimension(function (d) {
        var month = d.dsubmissiom.getMonth();
        return name[month] //+ '.' + name[day];
    });
    const group = dimension.group().reduce(
     function(p, v) { // add
       ++p.count;
       if(p.count > 0) {
         p.totalWords += v.n_of_words;
         p.avgWords = Math.floor(parseFloat(100*p.totalWords/p.count))/100;
         p.totalVocabulary += v.vocabulary_used;
         p.avgVocabulary = Math.floor(parseFloat(100*p.totalVocabulary/p.count))/100;
         if(v.project_id in p.p_ids){
           p.p_ids[v.project_id] += 1
         }
         else{
             p.p_ids[v.project_id] = 1;
             p.id_count++;
         }
       }
       else {
         p.avgWords = 0;
         p.totalWords = 0;
         p.totalVocabulary = 0;
         p.avgVocabulary = 0;
         p.id_count = 0;
         p.p_ids = {};
       }
       return p;
     },
     function(p, v) { // remove
       --p.count;
       if(p.count > 0) {
         p.totalWords -= v.n_of_words;
         p.avgWords = Math.floor(parseFloat(100*p.totalWords/p.count))/100;
         p.totalVocabulary -= v.vocabulary_used;
         p.avgVocabulary = Math.floor(parseFloat(100*p.totalVocabulary/p.count))/100;
         if(v.project_id in p.p_ids){
           p.p_ids[v.project_id] -= 1
         }
         if(p.p_ids[v.project_id] === 0){
             delete p.p_ids[v.project_id];
             p.id_count--;
         }
       }
       else {
         p.avgWords = 0;
         p.totalWords = 0;
         p.totalVocabulary = 0;
         p.avgVocabulary = 0;
         p.id_count = 0;
         p.p_ids = {};
       }
       return p;
     },
     function() { // init
         return {count: 0, totalWords: 0, avgWords: 0, totalVocabulary: 0, avgVocabulary: 0, id_count: 0, p_ids: {}};
     }
   );

    myChart
    .dimension(dimension)
    .group(group)
    .valueAccessor(function (p) {
       return p.value.count ;
     })
    .x(d3.scaleOrdinal().domain(name))
    .xUnits(dc.units.ordinal)
    .brushOn(false)
    .elasticY(true)
    .height(142)
    .barPadding(0.1)
    .outerPadding(0.05)
    .colors(["#065FE5"])
    //.renderLabel(true)
    //.label(function(d) {return Math.floor(d ) })
    // .title(function(d) {
    //    return d
    //  },
    //              'Value:  ' + Math.floor(+d.value.count* 100) / 100;})
    //.ordering(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'])
    .transitionDuration(1000)
    .margins({ top: 5, right: 30, bottom: 25, left: 50 })
    //.yAxis().ticks(6)
    //.yAxis().tickFormat(d3.format('s')).ticks(6)
    //.barPadding(0)
    //.alwaysUseRounding
    //.labelOffsetX(-50)
    //.fixedBarHeight(25)

    myChart.yAxis().ticks(6)
    myChart.xAxis().ticks(6)

    return myChart
}

export const BarChart1 = props => (
  <ChartTemplate chartFunction={barChartFunc} title={props.title} dim={props.dim} metric={props.metric}
   showMetricsSelector={props.showMetricsSelector}/>
)
